import React, { Fragment, useEffect, useState } from "react";
import "react-medium-image-zoom/dist/styles.css";
import { Document, Page, pdfjs } from "react-pdf";
import PrismaZoom from "react-prismazoom";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./CarouselImage.css";
import axiosInstance from "../../Middleware/axiosInstance";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const DemoCarousel = ({ Sources }) => {
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

    console.log("Sources:", Sources)
    const [src, setSrc] = React.useState(null);
    useEffect(() => {
        return () => {
            setSrc(null);
        };
    }, [Sources]);

    const [imageWrapperWidth, setImageWrapperWidth] = useState(0);
    // console.log("🚀 ~ file: CarouselImage.js ~ line 23 ~ DemoCarousel ~ imageWrapperWidth", window.outerWidth)
    useEffect(() => {
        function displayWindowSize() {
            // Get width and height of the window excluding scrollbars
            var resizeWith = document.documentElement.clientWidth;
            var resizeHeight = document.documentElement.clientHeight;

            // console.log("resize Width", resizeWith)
            if (resizeWith <= 1100) {
                setImageWrapperWidth(450);
            }
            if (resizeWith <= 1280) {
                setImageWrapperWidth(600);
            } else if (resizeWith <= 1650) {
                setImageWrapperWidth(700);
            } else {
                setImageWrapperWidth(900);
            }
        }

        // Attaching the event listener function to window's resize event
        window.addEventListener("resize", displayWindowSize);
    }, [window.outerWidth]);

    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    let thumb_images = null;

    const thumbnailItems = () => {
        return <Fragment></Fragment>;
    };
    thumb_images = Sources.map((Src, index) => {
        let URL = Src.src;
        return (
            <div
                className="images_thumb"
            >
                {Src.src.includes(".pdf") ? (
                    <div
                        onClick={() => {
                            console.log("SRC:", Src)
                            setSrc(Src);
                        }}
                    >
                        <Document
                            file={URL}
                            loading="Loading referral ..."
                            onLoadSuccess={onDocumentLoadSuccess}
                        >
                            <Page pageNumber={pageNumber} height={100} />
                        </Document>
                    </div>
                ) : (

                    <img
                        src={Src.src}
                        alt="img"
                        style={{ height: "100", width: "100", aspectRatio: 1 }}
                        onClick={() => {
                            setSrc(Src);
                        }}
                    />
                )}
            </div>
        );
    });

    return (
        <Fragment>
            <ToastContainer style={{ marginTop: '50px' }} />            
            <div className="image_thumb">
                {thumb_images}
            </div>
            <center className="showDocumets">
                {src != null && src.src.includes(".pdf") ? (
                    <div style={{ width: "100%", textAlign: "right" }}>
                        {src.backup_available===true && <div style={{ width: "100%", textAlign: "right" }}>
                            Note: use this option only when the referral view is blur or not readable:
                            <button style={{width:"270px"}} className="btn btn-primary " type="button" id="referral_resize_btn" onClick={() => {
                                // axios.post(`/oi/api/v1/referral/reset/${src.referral_id}`);
                                document.getElementById("referral_resize_btn").disabled = true;
                                document.getElementById("referral_resize_btn").innerHTML="Please wait...";
                                axiosInstance().get(`oi/api/v1/referral/reset/${src.referral_id}`).then(response=>{
                                    toast.success('Succesfully updated referral resolution.', {
                                        position: toast.POSITION.TOP_RIGHT
                                    });
                                    document.getElementById('referall_iframe').contentDocument.location.reload(true);
                                    document.getElementById("referral_resize_btn").disabled = false;
                                }).catch(err=>{
                                    console.error(err);
                                    toast.error('Unable to update referral resolution.', {
                                        position: toast.POSITION.TOP_RIGHT
                                    });
                                    document.getElementById('referall_iframe').contentDocument.location.reload(true);
                                    document.getElementById("referral_resize_btn").disabled = false;
                                }).finally(()=>{
                                    document.getElementById("referral_resize_btn").disabled = false;
                                    document.getElementById("referral_resize_btn").innerHTML="Reset to enhanced resolution"
                                })
                            }}>Reset to enhanced resolution</button>
                        </div>}
                        <iframe id="referall_iframe" className="pdfViewer" src={src.src}></iframe>
                    </div>
                ) : (
                    src != null && (
                        <div
                            className="referral_img"
                            style={{ height: imageWrapperWidth <= 1280 && "58vh" }}
                        >

                            <PrismaZoom>
                                <img
                                    src={src.src}
                                    alt="img"
                                    className="img"
                                />
                            </PrismaZoom>


                        </div>
                    )
                )}
            </center>
        </Fragment>
    );
};

export default DemoCarousel;
